export const MIN_PRODUCT_SEARCH_CHARACTERS = 3;
export const MIN_PROFESSIONAL_SEARCH_CHARACTERS = 3;
export const URL_SEARCH_PARAM = 'search';
export const TAG_CONFIRMATION_MESSAGE =
    'ArchiPro has been notified and will review this tag. Approval is usually given within 24 hours.';

export const NETWORK_PROFESSIONAL_BLACKLIST = [338969];
